'use client';

import { useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { authBus } from '@/lib/auth-bus';
import { IS_CN_SITE } from '@/config/site';
import { LoginPanel } from '@/components/LoginPanel';
import { cn } from '@/lib/utils';

type AuthMode = 'phone' | 'email' | 'google';
const DEFAULT_AUTH_MODE: AuthMode = IS_CN_SITE ? 'phone' : 'google';

export function LoginRequiredDialog() {
  const [open, setOpen] = useState(false);
  const [authMode, setAuthMode] = useState<AuthMode>(DEFAULT_AUTH_MODE);
  const expanded = IS_CN_SITE || authMode === 'phone';

  useEffect(() => {
    const handleLoginRequired = () => {
      setAuthMode(DEFAULT_AUTH_MODE);
      setOpen(true);
    };
    authBus.onLoginRequired(handleLoginRequired);
    return () => authBus.offLoginRequired(handleLoginRequired);
  }, []);

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      authBus.fireLoginCancelled();
      setAuthMode(DEFAULT_AUTH_MODE);
    }
    setOpen(nextOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className={cn(
          '!min-w-0 w-[calc(100%-2rem)] sm:w-full',
          expanded
            ? 'overflow-hidden border-0 bg-transparent p-0 shadow-none sm:max-w-[920px]'
            : 'sm:max-w-[400px]'
        )}
      >
        <LoginPanel
          layout="split"
          buttonContainerId="loginRequiredGoogleBtn"
          onSuccess={() => setOpen(false)}
          onAuthModeChange={setAuthMode}
        />
      </DialogContent>
    </Dialog>
  );
}
